export default __webpack_public_path__ + "static/media/vision.f56c5487.webp";